/* TWS rail relocator. The SHOP mega-menu rail is SERVER-RENDERED by
   snippets/tws-shop-rail.liquid (menu-driven via the 'shop-rail' navigation menu).
   This script only moves that markup into the header dropdown (desktop) and the
   drawer's SHOP panel (mobile). Tabs = CSS radios; mobile = native <details>. */
(function () {
  var cache = null;

  function grab() {
    if (cache) return cache;
    var src = document.getElementById('tws-rail-src');
    if (!src) return null;
    var rail = src.querySelector('.tws-rail');
    var mob = src.querySelector('.tws-m');
    cache = {
      trig: (src.getAttribute('data-trigger') || 'Shop').trim().toLowerCase(),
      rail: rail ? rail.outerHTML : '',
      mob: mob ? mob.outerHTML : ''
    };
    src.remove(); // avoid duplicate radio ids once relocated
    return cache;
  }

  function wireHover(wrap) {
    wrap.querySelectorAll('.tws-tab').forEach(function (l) {
      l.addEventListener('mouseenter', function () {
        var r = document.getElementById(l.getAttribute('for'));
        if (r) r.checked = true;
      });
    });
  }

  function relocate() {
    var c = grab();
    if (!c) return;
    // desktop dropdown
    if (c.rail) {
      var navItem = null;
      document.querySelectorAll('[data-link-title]').forEach(function (d) {
        if ((d.getAttribute('data-link-title') || '').trim().toLowerCase() === c.trig) navItem = d;
      });
      if (navItem) {
        var wrap = navItem.querySelector('.nav__sub-wrap');
        if (wrap && !wrap.classList.contains('tws-inj')) {
          wrap.classList.add('tws-inj');
          wrap.insertAdjacentHTML('afterbegin', c.rail);
          wireHover(wrap);
        }
      }
    }
    // mobile drawer
    if (c.mob) {
      var shopD = null;
      document.querySelectorAll('[id^="Details-menu-drawer-menu-item-"]').forEach(function (d) {
        var s = d.querySelector(':scope > summary');
        if (s && s.textContent.replace(/\s+/g, ' ').trim().toLowerCase() === c.trig) shopD = d;
      });
      if (shopD) {
        var w = shopD.querySelector('.drawer-nav__wrapper');
        if (w && !w.classList.contains('tws-minj')) {
          w.classList.add('tws-minj');
          var nl = w.querySelector('.list-menu'); if (nl) nl.style.display = 'none';
          var ac = w.querySelector('.drawer-nav__additional-content'); if (ac) ac.style.display = 'none';
          var h = w.querySelector('.drawer-nav__header');
          if (h) h.insertAdjacentHTML('afterend', c.mob);
          else w.insertAdjacentHTML('beforeend', c.mob);
        }
      }
    }
  }

  if (document.readyState !== 'loading') relocate();
  else document.addEventListener('DOMContentLoaded', relocate);
  setTimeout(relocate, 700); setTimeout(relocate, 1600);
  // mobile drawer builds lazily on first open
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.header-trigger__link--mobile,[aria-label="Menu"]');
    if (t) { setTimeout(relocate, 60); setTimeout(relocate, 400); }
  }, true);
  // theme editor re-renders the header without re-running this script
  ['shopify:section:load', 'shopify:section:select', 'shopify:block:select'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(relocate, 50); setTimeout(relocate, 450); });
  });
})();
